// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { InvitationLandingContext, OrganizationMemberRole, ProjectKey, ProjectTeamRole, TID } from "./TypeDefinitions.ts"

export interface Invitations {
  createInvitation(email: string, projectKey: ProjectKey | null, role: ProjectTeamRole | null, globalRole: OrganizationMemberRole | null, landingContext: InvitationLandingContext | null, userMessage: string | null): Promise<void>

  inviteMatterSupport(userMessage: string, taskId: TID | null): Promise<void>
}

export class InvitationsClient implements Invitations {
  constructor(private service: ApiService) {}

  async createInvitation(email: string, projectKey: ProjectKey | null, role: ProjectTeamRole | null, globalRole: OrganizationMemberRole | null, landingContext: InvitationLandingContext | null, userMessage: string | null): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Invitations/createInvitation", {
      email: email,
      projectKey: projectKey,
      role: role,
      globalRole: globalRole,
      landingContext: landingContext,
      userMessage: userMessage,
    }))
  }

  async inviteMatterSupport(userMessage: string, taskId: TID | null): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Invitations/inviteMatterSupport", {
      userMessage: userMessage,
      taskId: taskId,
    }))
  }

}

